// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","logo":"Header_logo__shVBB"};